export const PAGE_READY = 'global:pageready';
export const CLICK = 'global:click';
export const SCROLL = 'global:scroll';
export const READY = 'global:ready';
export const KEYUP = 'global:keyup';
export const RESIZE = 'global:resize';
export const UPDATE = 'global:update';
export const CHANGE = 'global:change';
export const TOUCHMOVE = 'global:touchmove';
export const TOUCHSTART = 'global:touchstart';
export const MOUSEOVER = 'global:mouseover';
export const MOUSEOUT = 'global:mouseout';
export const MOUSEENTER = 'global:mouseenter';
export const MOUSELEAVE = 'global:mouseleave';
export const UPDATE_STATS = 'global:updatestats';
export const SHOW_OVERLAY = 'global:show-overlay';
export const HIDE_OVERLAY = 'global:hide-overlay';
export const TRANSITIONEND = 'global:transitionend';
export const ANIMATIONEND = 'global:animationend';
export const PRESS = 'global:press';
export const TAP = 'global:tap';
export const DOUBLETAP = 'global:doubletap';
export const OWLTRANSLATED = 'global:owltranslated';
export const OWLCHANGE = 'global:owlchange';
export const OWLCHANGED = 'global:owlchanged';
export const OWLRESIZE = 'global:owlresize';
export const OWLINITIALIZE = 'global:owlinitialize';
export const OWLINITIALIZED = 'global:owlinitialized';
export const INPUTBLUR = 'global:blurinput';
export const INPUTFOCUS = 'global:focusinput';
export const SUBMIT = 'global:submitform';
export const FORMCHANGE = 'global:changeform';
export const RENDER_LAZY_IMAGES = 'global:render-lazy-images';
export const RENDER_VIDEOS = 'global:render-videos';
export const RERENDER_ALL = 'global:rerender-all';
export const BUTTON_FAVORITE_READY = 'global:button-favorite-ready';
export const FAVORITE_TEAMS_UPDATED = 'global:updatefavoriteteams';
export const FAVORITE_REPORTERS_UPDATED = 'global:updatefavoritereporters';
export const FAVORITES_UPDATED = 'global:updatefavorites';
export const FAVORITES_SAVED = 'global:savedfavorites';
export const FAVORITES_RETRIEVED = 'global:favoritesretrieved';
export const UPDATE_FAVORITE = 'global:updatefavorite';
export const BUTTON_FAVORITE_CLICK = 'global:button-favorite-click';
export const CHANGED_TABS = 'global:changedtabs';
export const FEED_LOADED = 'global:feedcomponentloaded';
export const REGISTER_PAGE_VIEW = 'global:registerpageview';
export const TRACK = 'global:track';
export const REFRESH_ADS = 'global:refreshads';
export const REFRESH_ADHESION = 'global:refreshadhesion';
export const GEORESPONSE = 'global:geolocationresponse';
export const RENDER_DROPDOWNS = 'global:render_dropdowns';
export const VIDEO_PLAYER_UPDATE = 'global:video_player_update';
export const VIDEO_PLAYER_PLAY = 'global:video-player-play';
export const VIDEO_PLAYER_PAUSE = 'global:video-player-pause';
export const MOUSEUP = 'global:mouseup';
export const MOUSEDOWN = 'global:mousedown';
export const MOUSEMOVE = 'global:mousemove';
export const HASHCHANGE = 'global:hashchange';
export const AUTOCOMPLETE_SELECT = 'global:autocomplete-select';
export const OUTBRAIN = 'global:outbrain';
export const OUTBRAIN_REFRESH = 'global:oubtrain-refresh';
export const OUTBRAIN_ENDSLATE_RENDER = 'global:oubtrain-endslate-render';
export const OUTBRAIN_ENDSLATE_DESTROY = 'global:oubtrain-endslate-destroy';
export const OPEN_POPUP = 'global:open-popup';
export const NAV_MOVED = 'global:nav-moved';



// WEBPACK FOOTER //
// ./~/unicorn/shared/enums/events.js